import React, { useState, useEffect, useLayoutEffect, useRef, Suspense, lazy, useCallback } from 'react'
import { Routes, Route, useSearchParams, useNavigate, useLocation, matchPath, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Helmet } from "react-helmet-async"
import { setDefaultOptions } from 'date-fns'

import parseJwt from './parseJwt'
import Loader from './Loader'
import ErrorBoundary from './ErrorBoundary'
//import { cookieGet, cookieUpdate } from './cookies'
import { useCookies } from 'react-cookie'

import { APIProvider } from '@vis.gl/react-google-maps'

import { MsalAuthenticationTemplate, useIsAuthenticated, useMsal, useMsalAuthentication, AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react"
import { InteractionType, InteractionStatus, EventType, InteractionRequiredAuthError } from "@azure/msal-browser"
import { msalConfig } from "./authConfig"

import { callApi } from './api/client'
import { signalrCon } from './api/signalrSlice'
import { HubConnectionState } from '@microsoft/signalr'

import { locale } from 'devextreme/localization'
import Notify from 'devextreme/ui/notify'
import { TextBox, Button as TextBoxButton } from 'devextreme-react/text-box'
import { Drawer, Button } from 'devextreme-react'

import { useTheme } from '@mui/material/styles'
import { Box, useMediaQuery } from '@mui/material'

import { setAccountId, userAccountId, setToken, setUser } from './components/user/userSlice'
import { setCompany, currentCompany } from './components/company/companySlice'

import themes from 'devextreme/ui/themes'

import Navbar from './components/nav/Navbar'
import SideBar from './components/nav/SideBar'

const drawerWidth = 258;

const Dashboard = lazy(() => import("./modules/Dashboard"));
const LiveMap = lazy(() => import("./modules/Activity/LiveMap"));
const TripGrid = lazy(() => import("./modules/Activity/TripGrid"));
const Support = lazy(() => import("./modules/Support"));
const UnknownDrivers = lazy(() => import("./modules/Dashboard/UnknownDrivers"));
const VehicleSelector = lazy(() => import("./components/vehicle/VehicleSelector"));
const UserSelector = lazy(() => import("./components/user/UserSelector"));
const User = lazy(() => import("./components/user/User"));
const Company = lazy(() => import("./components/company/Company"));
const CompanyGrid = lazy(() => import("./modules/Admin/CompanyGrid"));
const AssetSelector = lazy(() => import("./components/asset/AssetSelector"));
const Admin = lazy(() => import("./modules/Admin"));
const UserGrid = lazy(() => import("./modules/Admin/UserGrid"));
const VehicleGrid = lazy(() => import("./modules/Admin/VehicleGrid"));
const DeviceGrid = lazy(() => import("./modules/Admin/DeviceGrid"));
const DriverIdGrid = lazy(() => import("./modules/Admin/DriverIdGrid"));
const SensorGrid = lazy(() => import("./modules/Admin/SensorGrid"));
const AssetGrid = lazy(() => import("./modules/Admin/AssetGrid"));
const SpeedEditGrid = lazy(() => import("./modules/Admin/SpeedEditGrid"));
const SpeedEdit = lazy(() => import("./modules/Admin/SpeedEdit"));
const SmartTraxGrid = lazy(() => import("./modules/Admin/SmartTraxGrid"));
const MessagingContacts = lazy(() => import("./modules/Admin/MessagingContactGrid"));
const MessagingContact = lazy(() => import("./components/user/MessagingContact"));
const Contacts = lazy(() => import("./modules/Admin/ContactGrid"));
const Contact = lazy(() => import("./components/user/Contact"));
const VehicleLookupGrid = lazy(() => import("./modules/Admin/VehicleLookupGrid"));
const Groups = lazy(() => import("./modules/Admin/Groups"));
const Device = lazy(() => import("./components/device/Device"));
const Sensor = lazy(() => import("./components/device/Sensor"));
const SmartTrax = lazy(() => import("./components/device/SmartTrax"));
const Asset = lazy(() => import("./components/asset/Asset"));
const Vehicle = lazy(() => import("./components/vehicle/Vehicle"));
const VehicleLookup = lazy(() => import("./components/vehicle/VehicleLookup"));
const SmartSCREEN = lazy(() => import("./modules/smartSCREEN"));
const SmartScreenDetails = lazy(() => import("./modules/smartSCREEN/Details"));
const SmartID = lazy(() => import("./modules/smartID"));
const DataImport = lazy(() => import("./modules/Admin/DataImport"));
const ZoneGrid = lazy(() => import("./modules/Zones/ZoneGrid"));
const Zones = lazy(() => import("./modules/Zones"));
const Diagnostics = lazy(() => import("./modules/Diagnostics"));
const Report = lazy(() => import("./modules/Report"));
const ScheduleGrid = lazy(() => import("./modules/Report/ScheduleGrid"));
const Schedule = lazy(() => import("./modules/Report/ScheduleDetails"));
const ReportViewer = lazy(() => import("./modules/Report/Viewer"));
const ReportDesigner = lazy(() => import("./modules/Report/Designer"));
const SmartPOOLCAR = lazy(() => import("./modules/smartPOOLCAR"));
const SmartPOOLCARm = lazy(() => import("./modules/smartPOOLCAR/Mobile"));
const BookingAction = lazy(() => import("./modules/smartPOOLCAR/BookingAction"));
const BookingDetails = lazy(() => import("./modules/smartPOOLCAR/BookingDetails"));
const TripAllocation = lazy(() => import("./modules/Elogbook/TripAllocation"));
const PassengerGrid = lazy(() => import("./modules/smartTRANSIT/PassengerGrid"));
const Passenger = lazy(() => import("./modules/smartTRANSIT/Passenger"));
const TargetZERO = lazy(() => import("./modules/targetZERO"));

const App = (props) => {
    const prefixes = [
        'summitconnect/*'
    ]
    const navigate = useNavigate()
    const { pathname } = useLocation()
    const prefix = prefixes.find(p => matchPath(p, pathname))
    const theme = useTheme()
    const smallScreen = useMediaQuery(theme.breakpoints.down('md'))

    const [ cookies, setCookie ] = useCookies(['session_var'])

    const libs = [
        'geometry',
        'marker',
        'places',
        // 'drawing',
    ]
    const lsGrids = [
        'CompanyGrid',
        'AssetGrid',
        'DeviceGrid',
        'SensorGrid',
        'UserGrid',
        'VehicleGrid',
        'VehicleLookupGrid',
        'TripGrid',
        'ContactGrid',
        'ScheduleGrid',
        'BookingGrid',
        'SpeedEditGrid',
        'MsgContactGrid',
        'SmartTraxGrid',
        'DeviceLogsGrid',
        'DriverIdGrid',
        'CompanyTicketGrid',
        'VehicleTicketGrid',
    ]

    const dispatch = useDispatch()
    const currentcompany = useSelector(currentCompany)
    const signalr = useSelector(signalrCon)

    const pageRef = useRef(null)

    const [isLoading, setIsLoading] = useState(false)
    const [msalError, setMsalError] = useState()

    const [menuOpen, setMenuOpen] = useState(!smallScreen)
    const [contHeight, setContHeight] = useState('100%')

    const { instance, accounts, inProgress } = useMsal()
    const isAuthenticated = useIsAuthenticated()

    const authReq = {
        state: pathname,
        scopes: msalConfig.auth.scopes,
    }
    useEffect(() => {
        //console.log(`isAuthenticated: ${isAuthenticated}, inProgress: ${inProgress}`)
        if (inProgress === InteractionStatus.None) {
            instance.handleRedirectPromise()
                .then((authenticationResult) => {
                    if (authenticationResult) {
                        //console.log(`authenticationResult: ${JSON.stringify(authenticationResult)}`)
                        dispatch(setAccountId(authenticationResult.account.localAccountId))
                        if (authenticationResult.state) {
                            if (authenticationResult.state == '/') {
                                callApi('Users/GetLandingPage')
                                    .then(resp => {
                                        if (resp.page) {
                                            if (resp.page.startsWith('https://')) {
                                                window.location = resp.page
                                            } else {
                                                navigate(resp.page)
                                            }
                                        }
                                    }).catch(error =>
                                        Notify({
                                            message: error,
                                            minHeight: 45,
                                            minWidth: 150,
                                            type: 'error',
                                        }, {
                                            position: 'bottom center',
                                            direction: 'up-push'
                                        })
                                    )
                            } else {
                                navigate(authenticationResult.state)
                            }
                        }
                    }
                })
                .catch(err => {
                    console.log(`handleRedirectPromise: ${err}`)
                })

            if (!isAuthenticated) {
                if (prefix) {
                    authReq.extraQueryParameters = { theme: prefix.slice(0, -2) }
                }
                if (!msalError) {
                    instance.loginRedirect(authReq)
                        .catch(e => {
                            console.log(e)
                        })
                } else {
                    setTimeout(() => {
                        setMsalError()
                        instance.loginRedirect(authReq)
                            .catch(e => {
                                console.log(e)
                            })
                    }, 5000)
                }
            } else {
                //console.log(`isAuthenticated Account: ${JSON.stringify(accounts[0])}`)
                dispatch(setAccountId(accounts[0]?.localAccountId))
                getAuthDetails()
            }
        }
    }, [inProgress, isAuthenticated, accounts, instance]);

    useEffect(() => {
        if (currentcompany?.id !== 0) {
            const storecid = localStorage.getItem('cid')
            if (storecid !== null) {
                const scid = parseInt(storecid)
                if (scid !== NaN && scid !== currentcompany.id) {
                    lsGrids.forEach(i => {
                        const stritm = localStorage.getItem(i)
                        if (stritm !== null) {
                            try {
                                localStorage.removeItem(i)
                            } catch (err) {
                                console.error(err)
                            }
                        }
                    })
                }
            }
            localStorage.setItem('cid', currentcompany?.id.toString())
        }
    }, [currentcompany])
    useEffect(() => {
        themes.current(theme.devexpress)
        locale('en-AU')

        setDefaultOptions({ weekStartsOn: 1 })

        //console.log(`Cookies: ${JSON.stringify(cookies)}`)

        instance.addEventCallback((message) => {
            switch (message.eventType) {
                case EventType.LOGIN_SUCCESS:
                    //console.log(`LOGIN_SUCCESS:(path: ${pathname}) ${JSON.stringify(message)}`)
                    break
                case EventType.LOGIN_FAILURE:
                    console.log(`LOGIN_FAILURE: ${JSON.stringify(message)}`);
                    Notify({
                        message: message.error.errorMessage,
                        minHeight: 45,
                        minWidth: 150,
                        type: 'error',
                    }, {
                        position: 'bottom center',
                        direction: 'up-push'
                    })
                    setMsalError(message)
                    break
                case EventType.ACQUIRE_TOKEN_BY_CODE_FAILURE:
                    console.log(`ACQUIRE_TOKEN_BY_CODE_FAILURE: ${JSON.stringify(message)}`);
                    break
                case EventType.ACQUIRE_TOKEN_FAILURE:
                    console.log(`ACQUIRE_TOKEN_FAILURE: ${JSON.stringify(message)}`);
                    break
                default:
                    //console.log(`MSAL Event: ${JSON.stringify(message)}`);
                    break
            }
        })
    }, [])

    useLayoutEffect(() => {
        if (!!pageRef.current) {
            const h = pageRef.current.offsetHeight
            if (contHeight !== h) {
                setContHeight(h)
            }
        }
    },[])
    useEffect(() => {
        if (themes.current() !== theme.devexpress) {
            themes.current(theme.devexpress)
        }
        if (!!pageRef.current) {
            const h = window.innerHeight - pageRef.current.offsetTop
            if (contHeight !== h) {
                setContHeight(h)
            }
        }
        if (!smallScreen && !menuOpen) {
            setMenuOpen(true)
        }
        if (isAuthenticated && signalr.state === HubConnectionState.Disconnected) {
            dispatch({ type: 'connect'})
        }
    })

    const getAuthDetails = () => {
        //console.log(`getAuthDetails(${JSON.stringify(cookies.session_var)})`)
        callApi('Users/GetAuthDetails', {
            luid: cookies.session_var?.luid,
            muid: cookies.session_var?.muid,
            lcid: cookies.session_var?.lcid,
            mcid: cookies.session_var?.mcid,
        })
            .then(resp => {
                //if (process.env.REACT_APP_PartnerUri !== 'https://fleetconnect.com.au' && resp.comp.id !== 2) {
                //    window.location = 'https://fleetconnect.com.au/'
                //}
                //console.log(`Account: ${JSON.stringify(accounts[0])}`)
                if (resp.cookie) {
                    setCookie('session_var', JSON.stringify(resp.cookie), {
                        httpOnly: false,
                        path: '/',
                        secure: true,
                        domain: 'fleetconnect.com.au',
                    })
                }
                //console.log(`session_var(${JSON.stringify(resp.cookie)})`)
                dispatch(setUser(resp.user))
                dispatch(setCompany(resp.comp))
                dispatch({ type: 'connect' })
            }).catch(error =>
                Notify({
                    message: error,
                    minHeight: 45,
                    minWidth: 150,
                    type: 'error',
                }, {
                    position: 'bottom center',
                    direction: 'up-push'
                })
            )
    }

    const renderMenu = () => {
        const stateHandler = (newState) => setMenuOpen(newState);
        return (
            <SideBar setDrawerState={stateHandler} />
        );
    }
    return (
        <>
            <AuthenticatedTemplate>
                <Drawer
                    opened={menuOpen}
                    openedStateMode={smallScreen ? 'overlap' : 'shrink'}
                    revealMode='slide'
                    height='100vh'
                    width='100%'
                    maxSize={drawerWidth}
                    render={renderMenu}>
                    <Box component="main" sx={{ width: '100%', height: '100vh' }} >
                        <ErrorBoundary>
                            <Navbar setDrawerState={setMenuOpen} drawerState={menuOpen} />
                        </ErrorBoundary>
                        <Box ref={pageRef} sx={{ height: contHeight, overflow: 'auto' }}>
                            <ErrorBoundary>
                                <APIProvider apiKey='AIzaSyDam2sbZrFeXcMAWFV65piQC44TnVQg0uk' libraries={libs}>
                                    <Suspense fallback={<Loader />}>
                                        <Routes>
                                            <Route path="/:prefix" element={<Dashboard />} />
                                            <Route path="/" element={<Dashboard />} />
                                            <Route path="/Dashboard/UnknownDrivers" element={<UnknownDrivers />} />
                                            <Route path="/Vehicles" element={<VehicleSelector />} />
                                            <Route path="/Drivers" element={<UserSelector />} />
                                            <Route path="/Assets" element={<AssetSelector />} />
                                            <Route path="/LiveMap" element={<LiveMap />} />
                                            <Route path="/Trips" element={<TripGrid />} />
                                            <Route path="/Support" element={<Support />} />
                                            <Route path="/Admin" element={<Admin />} />
                                            <Route path="/Admin/Companies" element={<CompanyGrid />} />
                                            <Route path="/Admin/Company" element={<Company />} />
                                            <Route path="/Admin/Users" element={<UserGrid />} />
                                            <Route path="/Admin/User" element={<User />} />
                                            <Route path="/Admin/Devices" element={<DeviceGrid />} />
                                            <Route path="/Admin/Device" element={<Device />} />
                                            <Route path="/Admin/Vehicles" element={<VehicleGrid />} />
                                            <Route path="/Admin/Vehicle" element={<Vehicle />} />
                                            <Route path="/Admin/Assets" element={<AssetGrid />} />
                                            <Route path="/Admin/Asset" element={<Asset />} />
                                            <Route path="/Admin/DriverIds" element={<DriverIdGrid />} />
                                            <Route path="/Admin/Sensors" element={<SensorGrid />} />
                                            <Route path="/Admin/Sensor" element={<Sensor />} />
                                            <Route path="/Admin/SpeedEdit" element={<SpeedEdit />} />
                                            <Route path="/Admin/SpeedEditGrid" element={<SpeedEditGrid />} />
                                            <Route path="/Admin/Contacts" element={<Contacts />} />
                                            <Route path="/Admin/Contact" element={<Contact />} />
                                            <Route path="/Admin/SmartTraxGrid" element={<SmartTraxGrid />} />
                                            <Route path="/Admin/SmartTrax" element={<SmartTrax />} />
                                            <Route path="/Admin/MessagingContacts" element={<MessagingContacts />} />
                                            <Route path="/Admin/MessagingContact" element={<MessagingContact />} />
                                            <Route path="/Admin/VehicleLookups" element={<VehicleLookupGrid />} />
                                            <Route path="/Admin/VehicleLookup" element={<VehicleLookup />} />
                                            <Route path="/Admin/Groups" element={<Groups />} />
                                            <Route path="/Admin/DataImport" element={<DataImport />} />
                                            <Route path="/smartSCREEN" element={<SmartSCREEN />} />
                                            <Route path="/smartSCREEN/Details" element={<SmartScreenDetails />} />
                                            <Route path="/smartID" element={<SmartID />} />
                                            <Route path="/Zones/ZoneGrid" element={<ZoneGrid />} />
                                            <Route path="/Zones" element={<Zones />} />
                                            <Route path="/Diagnostics" element={<Diagnostics />} />
                                            <Route path="/Report" element={<Report />} />
                                            <Route path="/Report/Schedules" element={<ScheduleGrid />} />
                                            <Route path="/Report/Schedule" element={<Schedule />} />
                                            <Route path="/Report/Viewer" element={<ReportViewer />} />
                                            <Route path="/Report/Designer" element={<ReportDesigner />} />
                                            <Route path="/smartPOOLCAR" element={smallScreen ? <SmartPOOLCARm /> : <SmartPOOLCAR />} />
                                            <Route path="/smartPOOLCAR/BookingAction/:id" element={<BookingAction />} />
                                            <Route path="/smartPOOLCAR/BookingAction/" element={<BookingAction />} />
                                            <Route path="/smartPOOLCAR/BookingDetails/" element={<BookingDetails />} />
                                            <Route path="/:prefix/Elogbook/TripAllocation/:id" element={<TripAllocation />} />
                                            <Route path="/Elogbook/TripAllocation/:id" element={<TripAllocation />} />
                                            <Route path="/smartTRANSIT/Passengers" element={<PassengerGrid />} />
                                            <Route path="/smartTRANSIT/Passenger" element={<Passenger />} />
                                            <Route path="/targetZERO" element={<TargetZERO />} />
                                        </Routes>
                                    </Suspense>
                                </APIProvider>
                            </ErrorBoundary>
                        </Box>
                    </Box>
                </Drawer>
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
            </UnauthenticatedTemplate>
        </>
    );
}
export default App
